import apiClient from './api/apiService';
import { getUrlWithQueryParams } from './api/getUrlWithQueryParams';

const BASE_URL = '/v1/companies-models-access';

export const getBuyerModels = async (
  page: number,
  perPage: number,
  searchBy: string,
  buyerId: number | null,
  sellerId: number | null
): Promise<any> => {
  const url = `${BASE_URL}`;
  const queryParamsObj = {
    page: page,
    per_page: perPage,
    search_term: searchBy,
    company_buyer_id: buyerId,
    company_seller_id: sellerId,
  };
  const fullUrl = getUrlWithQueryParams(url, queryParamsObj);
  const { data } = await apiClient.get<any>(fullUrl);

  return data.data;
};

export const toggleOrderBuyerModel = async (
  modelId: number,
  canOrderInternally?: boolean,
  canOrderExternally?: boolean
): Promise<any> => {
  const url = `${BASE_URL}/${modelId}`;
  const body = {
    can_order_internally: canOrderInternally ?? undefined,
    can_order_externally: canOrderExternally ?? undefined,
  };
  const { data } = await apiClient.patch<any>(url, body);

  return data.data;
};

export const toggleOrderAllModels = async (
  buyerId: number,
  companyId: number,
  canOrderInternally?: boolean,
  canOrderExternally?: boolean
): Promise<any> => {
  const url = `${BASE_URL}/all-models`;
  const body = {
    company_buyer_id: buyerId,
    company_seller_id: companyId,
    can_order_internally: canOrderInternally ?? undefined,
    can_order_externally: canOrderExternally ?? undefined,
  };
  const { data } = await apiClient.patch<any>(url, body);

  return data.data;
};

export const deleteBuyerModel = async (modelId: number): Promise<any> => {
  const url = `${BASE_URL}/${modelId}`;
  const { data } = await apiClient.delete<any>(url);
  return data.data;
};

export const getBuyersEligibleModels = async (
  page: number,
  perPage: number,
  searchBy: string,
  companyId: number | null,
  buyerId: number | null
): Promise<any> => {
  const url = `${BASE_URL}/eligible-models`;
  const queryParamsObj = {
    page: page,
    per_page: perPage,
    search_term: searchBy,
    company_seller_id: companyId,
    company_buyer_id: buyerId,
  };
  const fullUrl = getUrlWithQueryParams(url, queryParamsObj);
  const { data } = await apiClient.get<any>(fullUrl);

  return data.data;
};

export const addModelToBuyer = async (
  companyId: number,
  buyerId: number,
  modelId: number
) => {
  const body = {
    model_id: modelId,
    company_seller_id: companyId,
    company_buyer_id: buyerId,
  };
  const url = `${BASE_URL}`;
  const { data } = await apiClient.post(url, body);

  return data.data;
};
